import { useMemo } from 'react';
import { useStyle } from './style'
import InputFileCard from '../InputFileCard'

interface RequestBubbleProps {
  content: string
  images: string[]
  docs: any[]
}

const RequestBubble = ({ content, images, docs }: RequestBubbleProps) => {
  const { styles } = useStyle();

  // 使用 useMemo 统一处理数据转换逻辑
  const files = useMemo(() => {
    // 转换图片
    const imageFiles = (images || []).map((img) => ({
      id: img.id,
      name: img.id,
      size: 0,
      type: 'image/jpeg',
      url: img.url,
    }));

    // 转换文档
    const docFiles = (docs || []).map((doc, index) => ({
      id: doc.id || `doc-${index}`, // 优先使用 doc 自身的 id
      name: doc.docName || `document-${index}`,
      size: doc.docSize || 0,
      type: 'application/octet-stream',
      url: doc.docUrl,
    }));

    return [...imageFiles, ...docFiles];
  }, [images, docs]);

  return (
    <div className={styles.userMessage}>
      {files.length > 0 && (
        <div >
          {files.map((file) => (
            <InputFileCard
              key={file.id}
              file={file}
            />
          ))}
        </div>
      )}
      <div className={styles.messageText}>{content}</div>
    </div>
  );
};

export default RequestBubble
